module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-z6-8fdde043e40e2f813c5547850332dd10.svg";